import { createReducer, on } from "@ngrx/store";
import { TableComponentState } from "../../shared/types/TableComponentState";
import { InternalTransferActions, TransactionFormActions, TweActions } from "../actions";
import { AccountInfoActions } from "../../account-info-header/actions";

export const tweTableStateKey = 'tweTableState';

export interface State extends TableComponentState {
}

export const initialTweTableState: State = {
    loading: false,
    error: '',
    hasError: false,
    gridReady: false,
    isInitialLoad: true,
    printClicked: false
};

export const tweTableStateReducer = createReducer(
    initialTweTableState,
    on(TweActions.gridReady, (state, action) => {
        return {
            ...state,
            gridReady: action.gridReady
        }
    }),
    on(InternalTransferActions.verifyCallSuccessful,
        TransactionFormActions.loadChecksReviewPageWithoutVerifyCall,
        TransactionFormActions.loadInternalTransferWithoutVerifyCall, 
        AccountInfoActions.verifyTaxWithholdingsSuccess, (state) => {
        return {
            ...state,
            loading: false,
            hasError: false,
        };
    }),
    on(InternalTransferActions.verifyCallFail, (state, err) => {
        return {
            ...state,
            loading: false,
            error: err.message,
            hasError: true,
        };
    })
);
